module.exports = __webpack_public_path__ + "static/customer-history-5ca6774a1a7802aee9fdd170db13d97a.png";